<template>
  <div :class="componentClassName">
    <date-picker
      ref="datepicker"
      v-model="date"
      locale="ja"
      :model-config="modelConfig"
      :popover="{ placement: 'bottom', visibility: 'focus' }"
      :inline="true"
      :masks="masks"
      :min-date="minDate"
      :max-date="maxDate"
      :disabled-dates="disabledDates"
    >
      <template #header-left-button>
        <div class="a-calendar-field__nav-button a-calendar-field__nav-button--prev">
          <div class="a-calendar-field__nav-button-icon">
            <a-icon icon="chevron-left" color="white" />
          </div>
          <div v-if="navTooltipPrevious" class="a-calendar-field__nav-button-tooltip">
            <svg width="8.666" height="16" viewBox="0 0 8.666 16">
              <path
                d="M7.265.8a1,1,0,0,1,1.47,0l5.716,6.192a1,1,0,0,1-.735,1.678H2.284a1,1,0,0,1-.735-1.678Z"
                transform="translate(8.666) rotate(90)"
                fill="#4d4d4d"
              />
            </svg>
            {{ navTooltipPreviousMessage }}
          </div>
        </div>
      </template>
      <template #header-right-button>
        <div class="a-calendar-field__nav-button a-calendar-field__nav-button--next">
          <div class="a-calendar-field__nav-button-icon">
            <a-icon icon="chevron-right" color="white" />
          </div>
          <div v-if="navTooltipNext" class="a-calendar-field__nav-button-tooltip">
            <svg width="8.666" height="16" viewBox="0 0 8.666 16">
              <path
                d="M7.265.8a1,1,0,0,1,1.47,0l5.716,6.192a1,1,0,0,1-.735,1.678H2.284a1,1,0,0,1-.735-1.678Z"
                transform="translate(0 16) rotate(-90)"
                fill="#4d4d4d"
              />
            </svg>
            {{ navTooltipNextMessage }}
          </div>
        </div>
      </template>
      <template #default="{ inputEvents }">
        <div class="a-calendar-field__field">
          <div class="a-calendar-field__icon">
            <a-icon icon="calendar-outline" color="grey" />
          </div>
          <input
            :id="id"
            ref="input"
            class="a-calendar-field__input"
            :placeholder="placeholder"
            :value="dateValue"
            v-on="inputEvents"
          />
        </div>
      </template>
    </date-picker>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import { DatePicker } from 'v-calendar';
import AIcon from '@/components/atoms/icon';
import Cleave from 'cleave.js';
import * as dateFns from 'date-fns';

export default {
  name: 'a-calendar-field',
  components: {
    AIcon,
    DatePicker,
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    minDate: {
      type: Date,
      default: null,
    },
    maxDate: {
      type: Date,
      default: null,
    },
    disabledDates: {
      type: Array,
      default: null,
    },
    modelValue: {
      type: String,
      default: null,
    },
    placeholder: {
      type: String,
      default: '休業日',
    },
    navTooltipPrevious: {
      type: Boolean,
      default: false,
    },
    navTooltipNext: {
      type: Boolean,
      default: false,
    },
    navTooltipPreviousMessage: {
      type: String,
      default: null,
    },
    navTooltipNextMessage: {
      type: String,
      default: null,
    },
    id: {
      type: String,
      default: '',
    },
  },
  emits: ['change', 'update:modelValue'],
  data() {
    return {
      modelConfig: {
        type: 'string',
        mask: 'YYYY / MM / DD',
      },
      masks: {
        title: 'YYYY年 MMM',
        input: 'YYYY / MM / DD',
      },
      date: null,
      inputMask: null,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('a-calendar-field');
      return `${baseClassName} ${this.class}`.trim();
    },
    dateValue() {
      return this.date;
    },
  },
  watch: {
    date(val, oldVal) {
      const output = this.toISO(val);
      this.$emit('update:modelValue', output);
      this.$emit('change', output);
    },
    modelValue(val, oldVal) {
      this.date = this.toFormatted(val);
    },
  },
  mounted() {
    if (this.$refs.input) {
      new Cleave(this.$refs.input, {
        date: true,
        delimiter: ' / ',
        datePattern: ['Y', 'm', 'd'],
      });
    }
    if (this.modelValue) {
      this.date = this.toFormatted(this.modelValue);
    }
  },
  methods: {
    toISO(dateText) {
      if (dateText) {
        return dateFns.format(dateFns.parse(dateText.replace(/\s/gi, ''), 'yyyy/MM/dd', new Date()), 'yyyy-MM-dd');
      }
      return dateText;
    },
    toFormatted(dateText) {
      if (dateText && dateText.indexOf('-') !== -1) {
        // convert formating
        return dateFns.format(dateFns.parseISO(dateText), 'yyyy / MM / dd');
      }
      return dateText;
    },
  },
};
</script>
